import styled from 'styled-components';

export default styled.input`
  font-size: 1em;
  padding: 0.25em;
  border-radius: 3px;
  max-height: 50px;

  color: ${props => props.theme.background.secondary};
  border: 2px solid ${props => props.theme.accent.primary};
  font-family: ${({ theme }) => theme.fonts.main};
`;
